import { createAction, props } from '@ngrx/store';

export const fetchBanners = createAction(
  '[Banner] Fetch Banners',
  props<{ page, filterOptions }>()
);

export const fetchBannersSuccess = createAction(
  '[Banner] Fetch Banners Success',
  props<{ banner }>()
);

export const fetchBannersFailure = createAction(
  '[Banner] Fetch Banners Faild',
  props<{ error }>()
);

export const fetchBanner = createAction(
  '[Banner] Fetch Banner',
  props<{ id }>()
);

export const fetchBannerSuccess = createAction(
  '[Banner] Fetch Banner Success',
  props<{ banner }>()
);

export const fetchBannerFailure = createAction(
  '[Banner] Fetch Banner Faild',
  props<{ error }>()
);

export const fetchFilteredBanners = createAction(
  '[Banner] Fetch Filtered Banners',
  props<{ page, filterOptions }>()
);

export const fetchFilteredBannersSuccess = createAction(
  '[Banner] Fetch Filtered Banners Success',
  props<{ banners }>()
);

export const fetchFilteredBannersFailure = createAction(
  '[Banner] Fetch Filtered Banners Faild',
  props<{ error }>()
);

export const addBanner = createAction(
  "[Banner] Add",
  props<{ banner }>()
);

export const addBannerSuccess = createAction(
  "[Banner] Add Success",
  props<{ banner }>()
);

export const addBannerFailure = createAction(
  "[Banner] Add Failure",
  props<{ error }>()
);

export const updateBanner = createAction(
  "[Banner] Update",
  props<{ banner }>()
);

export const updateBannerSuccess = createAction(
  "[Banner] Update Success",
  props<{ banner }>()
);

export const updateBannerFailure = createAction(
  "[Banner] Update Failure",
  props<{ error }>()
);

export const deleteBanner = createAction(
  "[Banner] Delete",
  props<{ id }>()
);

export const deleteBannerSuccess = createAction(
  "[Banner] Delete Success",
  props<{ id }>()
);

export const deleteBannerFailure = createAction(
  "[Banner] Delete Failure",
  props<{ error }>()
);

